import React, { useState } from "react";
import "./TutorialSection.scss";
import Modal from "shared/ui/Modal";
import VideoFrame from "shared/ui/VideoFrame";

interface TutorialCardProps {
  image: string;
  alt?: string;
  width?: number;
  videoUrl?: string;
  videoTitle?: string;
  videoSubTilte?: string;
}

const TutorialCard: React.FC<TutorialCardProps> = ({
                                                     videoUrl = "",
                                                     image,
                                                     alt,
                                                     width= 200,
                                                     videoTitle,
                                                     videoSubTilte
                                                   }) => {
  const [showModalVideo, setShowModalVideo] = useState<boolean>(false);

  return (
    <>
      <div className="tutorial-card" onClick={() => {setShowModalVideo(true)}}>
        <img src={image} alt={alt || "tutorial"} width={width}/>
        <div className="play-overlay">
          <div className="play-button">
            <div className="triangle" />
          </div>
        </div>
        {videoTitle && (
          <div className="tutorial-card__title">
            {videoTitle}
          </div>
        )}
      </div>
      {showModalVideo &&
          <Modal
              onClose={() => setShowModalVideo(false)} isOpen={showModalVideo} title={videoTitle} infoModal={true}
              type={"info"}>
              <VideoFrame url={videoUrl}>
                  <span className="text-primary bold">{videoTitle ? `${videoTitle} : ` : ''} </span>
                  <span className="text-danger text-center"> {videoSubTilte}</span>
              </VideoFrame>
          </Modal>
      }
    </>

  );
};


export default TutorialCard;